import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import rootReducer from './reducers';

const config = (initialState) => {
  const middlewares = [thunkMiddleware];
  const devInClient =
    process.env.NODE_ENV === 'development' && process.env.IN_BROWSER === true;

  const createStoreWithMiddleware = compose(
    applyMiddleware(...middlewares),
    devInClient && window.devToolsExtension
      ? window.devToolsExtension()
      : (f) => f
  )(createStore);

  const store = createStoreWithMiddleware(rootReducer, initialState);

  store.additionalReducers = {};

  return store;
};

export default config;
